/**
 * Get the locale string from the state {language, country} (e.g. "en-US")
 * Adapted from https://git.i.mercedes-benz.com/dh-io-mbmxp/owc-fe-libs/blob/develop/packages/connection-aem-translations/src/connections/index.ts#L35
 */
export function getLocale(state: { language: string; country: string }) {
  return `${state.language}-${state.country}`;
}
